import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {isEmpty} from "../../__snowpack__/pkg/lodash.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const PromotionStatus = {
  UPCOMING: "UPCOMING",
  STOPING: "STOPING",
  ONGOING: "ONGOING",
  PAUSE: "PAUSE",
  EXPIRED: "EXPIRED"
};
const TabsColumns = [
  {
    title: "Ongoing",
    type: PromotionStatus.ONGOING,
    count: null
  },
  {
    title: "Upcoming",
    type: PromotionStatus.UPCOMING,
    count: null
  },
  {
    title: "temporaryStopping",
    type: PromotionStatus.PAUSE,
    count: null
  },
  {
    title: "Expired",
    type: PromotionStatus.EXPIRED,
    count: null
  }
];
export const usePromotionManage = () => {
  const [promotionList, setPromotionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [PromotionCountList, setPromotionCountList] = useState(TabsColumns);
  const [isGuide, setIsGuide] = useState(false);
  const [DetailInfo, setDetailInfo] = useState({
    shopName: null,
    name: null,
    externalStatus: null
  });
  const [ProductList, setProductList] = useState([]);
  const [IsSyncProduct, setIsSyncProduct] = useState(false);
  const [PromotionTplList, setPromotionTplList] = useState([]);
  const fetchPromotionList = async (pageInfo, query) => {
    setLoading(true);
    try {
      const {
        data: {content, number: page, size, totalPages, totalElements}
      } = await axios.post("/saas/promotion/list", {
        ...query,
        page: pageInfo && pageInfo.page - 1,
        size: pageInfo && pageInfo.size
      });
      if (!isEmpty(content)) {
        content.map((item) => {
          item.isShowMore = false;
          item.IsSync = false;
        });
        setPromotionList(content);
        if (isGuide) {
          getPromotionsCheck();
        }
      } else {
        setPromotionList([]);
        getPromotionsCheck();
      }
      return {
        promotionList: content,
        pageInfo: {
          page: page + 1,
          size,
          total: totalElements,
          totalPages
        }
      };
    } catch (error) {
      handleError(error);
      return {
        promotionList,
        pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  const getPromotionsCheck = async () => {
    const {
      data: {promotionCount}
    } = await axios.post("saas/promotion/check");
    setIsGuide(promotionCount > 0 ? false : true);
  };
  const fetchPromotionCountList = async (params) => {
    try {
      const queryParams = {...params};
      delete queryParams.externalStatus;
      const {data} = await axios.post("saas/promotion/count", queryParams);
      let results = PromotionCountList.map((item) => {
        let tabItem = data.find((tab) => tab.status === item.type);
        if (!isEmpty(tabItem)) {
          return {
            ...item,
            count: tabItem.count
          };
        } else {
          return {
            ...item,
            count: null
          };
        }
      });
      setPromotionCountList(results);
      return {
        promotionCountList: results
      };
    } catch (error) {
      handleError(error);
      PromotionCountList.map((item) => item.count = null);
      setPromotionCountList(PromotionCountList);
    } finally {
      return {
        promotionCountList: PromotionCountList
      };
    }
  };
  const fetchPromotionsDetail = async (promotionsId, queries) => {
    try {
      setLoading(true);
      const {data} = await axios.post("saas/promotion/get", {id: promotionsId});
      setDetailInfo(data);
      if (!isEmpty(data.promotionProducts)) {
        data.promotionProducts.map((item) => {
          item.promotionVariations = ["SHOPEE_ID", "BUKALAPAK_ID", "TOKOPEDIA_ID"].includes(queries.channelId) ? !isEmpty(item.promotionVariations) && item.promotionVariations.filter((child) => child.enabled) : item.promotionVariations;
        });
        setProductList(data.promotionProducts || []);
      }
      setIsSyncProduct(data.productNeedSync);
      return {
        detailInfo: data,
        detailProductList: data.promotionProducts,
        IsSyncProduct: data.productNeedSync
      };
    } catch (error) {
      handleError(error);
      return {
        detailInfo: DetailInfo,
        detailProductList: ProductList,
        IsSyncProduct
      };
    } finally {
      setLoading(false);
    }
  };
  const fetchPromotionTplList = async (channelId) => {
    try {
      const {data} = await axios.post("saas/promotion/list-tpl-simple", {channelId});
      setPromotionTplList(data);
      return {
        promotionTplList: PromotionTplList
      };
    } catch (error) {
      handleError(error);
      return {
        promotionTplList: []
      };
    } finally {
    }
  };
  return {
    isLoading: loading,
    promotionList,
    fetchPromotionList,
    promotionCountList: PromotionCountList,
    fetchPromotionCountList,
    isGuide,
    detailInfo: DetailInfo,
    fetchPromotionsDetail,
    detailProductList: ProductList,
    isSyncProduct: IsSyncProduct,
    promotionTplList: PromotionTplList,
    fetchPromotionTplList
  };
};
export const usePromotionManageModal = createModel(usePromotionManage);
